import React from "react";
import dayjs from "dayjs";
import { CircularProgress } from "@mui/material";

// ✅ SAME STATUS COLORS AS YOUR FIRST WORKING CODE
const getStatusClasses = (status) => {
  if (!status) return "bg-gray-50 text-gray-600 border border-gray-200";

  switch (status.toLowerCase()) {
    case "success":
      return "bg-[#DCFCE7] text-[#016630]";
    case "failed":
      return "bg-red-50 text-red-600";
    case "pending":
      return "bg-blue-50 text-blue-600";
    default:
      return "bg-gray-50 text-gray-600";
  }
};

const PaymentHistory = ({ payments = [], isLoading }) => {
  return (
    <div className="overflow-hidden rounded-xl border border-gray-200">

      {/* 🔥 Scrollable table body */}
      <div className="max-h-[60vh] overflow-y-auto">
        <table className="w-full text-sm text-left">
          <thead className="bg-[#4a7c8f] text-[#FFFFFF] font-inter text-[12px] uppercase sticky top-0 z-10">
            <tr>
              <th className="px-5 py-4 font-medium">Date</th>
              <th className="px-4 py-4 font-medium">Time</th>
              <th className="px-4 py-4 font-medium">Location</th>
              <th className="px-4 py-4 font-medium">Status</th>
              <th className="px-4 py-4 font-medium">Amount</th>
              <th className="px-4 py-4 font-medium">Payment Method</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-100">
            {isLoading ? (
              <tr>
                <td colSpan="6" className="text-center py-6 text-gray-500">
                  <CircularProgress size={24} />
                </td>
              </tr>
            ) : payments.length > 0 ? (
              payments.map((p, idx) => (
                <tr key={idx} className="hover:bg-gray-50">
                  <td className="px-5 py-3 text-[#101828] font-inter text-[14px]">
                    {dayjs(p.created_on).format("MM/DD/YYYY")}
                  </td>

                  <td className="px-4 py-3 text-[#101828] font-inter text-[14px]">
                    {p.created_at}
                  </td>

                  <td className="px-4 py-3 text-[#101828] font-inter text-[14px]">
                    {p.payment_location}
                  </td>

                  <td className="px-4 py-3">
                    <span
                      className={`inline-flex items-center px-2 py-1 text-xs font-semibold font-inter rounded-full ${getStatusClasses(
                        p.payment_status
                      )}`}
                    >
                      {p.payment_status.charAt(0).toUpperCase() +
                        p.payment_status.slice(1)}
                    </span>
                  </td>

                  <td className="px-4 py-3 text-[#101828] font-inter text-[14px]">
                    ${parseFloat(p.amount).toFixed(2)}
                  </td>

                  {/* ✅ FIXED ERROR — Missing closing quote */}
                  <td className="px-4 py-3 text-[#101828] font-inter text-[14px]">
                    {p.method}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center py-6 text-gray-500">
                  No payment history found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PaymentHistory;
